module.exports = __webpack_public_path__ + "img/guajiang.a56c9eb2.png";